import React, { useEffect, useMemo, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Loader from '../Loader';
import * as MinistryReportApi from '../../api/MinistryReportApi';
import { toast } from 'react-toastify';
import { useRef } from 'react';

import IncidentListingModal from './IncidentListingModal';

const MinistryDonutChart = ({
  data,
  height = 280,
  width = 450,
  isLoading,
  selectedDatee,
  selectedShift,
}) => {
  const categoryColors = {
    drivedownload: 'rgb(254, 195, 190)',
    contentdelivery: 'rgb(224,224,224)',
    contentprocess: 'rgb(255,224,143)',
    entryofcandidates: 'rgb(203,235,174)',
    registration: 'rgb(179,218,244)',
    aadharauthentication: 'rgb(187,211,218)',
    examcommencement: 'rgb(223,194,238)',
    allowedcandidateslogin: 'rgb(121,159,229)',
    examcompletion: 'rgb(144,132,219)',
    lockunlockincidents: 'rgb(122,234,203)',
  };

  const DEFAULT_INCIDENT_DETAILS_MODAL = {
    center_id: null,
    show: false,
    title: 'Incident Details',
  };
  const [showIncidentDetailsModal, setShowIncidentDetailsModal] = useState(
    DEFAULT_INCIDENT_DETAILS_MODAL
  );

  const [selectedStage, setSelectedStage] = useState(null);

  const dataRef = useRef(data);

  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const [modalData, setModalData] = useState([]);

  const [filter, setFilter] = useState({
    stage: '',
    date: '',
    shift: '',
  });

  const fetchModalData = async () => {
    const response = await MinistryReportApi.getStageIncidents(filter);

    if (response?.success) {
      setModalData(response?.data);
    } else {
      toast.error(`Error fetching stage incidents:  ${response?.message}`);
    }
  };

  useEffect(() => {
    if (filter.stage) {
      fetchModalData();
    }
  }, [filter.stage]);

  useEffect(() => {
    setFilter((prev) => ({
      stage: '',
      date: selectedDatee,
      shift: selectedShift,
    }));
  }, [selectedDatee, selectedShift]);

  const [chartData, setChartData] = useState({});
  useEffect(() => {
    setChartData({
      series: [0],
      options: {
        chart: {
          type: 'donut',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const clickedStage =
                dataRef.current[config?.dataPointIndex].stage;
              setSelectedStage(clickedStage);

              setFilter((prev) => ({
                ...prev,
                stage: clickedStage,
              }));
              setShowIncidentDetailsModal((prev) => ({ ...prev, show: true }));
            },
          },
        },
        legend: {
          show: true,
          position: 'bottom', // Legend at bottom

          floating: false, // Prevent legend from overlapping chart
        },
        labels: [], // Initialize labels to prevent undefined issues
        dataLabels: {
          enabled: true,
          formatter: (value, { seriesIndex, w }) => {
            return w.config.series[seriesIndex]; // Show raw count instead of percentage
          },
        },
        tooltip: {
          y: {
            formatter: (value) => `${value} Incidents`,
          },
        },
      },
    });
  }, [data]);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const series = data.map((item) => item.count);
      const labels = data.map((item) => item.stage);
      const colors = data.map(
        (item) =>
          categoryColors[item.stage.toLowerCase().replace(/[^a-z0-9]/g, '')] ||
          'rgb(200,200,200)' // Default fallback color
      );

      setChartData((prev) => ({
        ...prev,
        series,
        options: {
          ...prev.options,
          labels, // Ensure labels are assigned correctly
          colors,
        },
      }));
    }
  }, [data]);

  if (!data || data.length === 0) {
    return (
      <div
        style={{ height: height, width: '100%' }}
        className='d-flex justify-content-center align-items-center text-center'
      >
        No data available, Please select exam day/shift filters to see past exam
        days data.
      </div>
    );
  }
  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type='donut'
          height={height}
          width={width}
        />
      )}
      {showIncidentDetailsModal.show && (
        <IncidentListingModal
          showIncidentDetailsModal={showIncidentDetailsModal}
          setShowIncidentDetailsModal={setShowIncidentDetailsModal}
          incidents={modalData}
          selectedStage={selectedStage}
        />
      )}
    </div>
  );
};

export default MinistryDonutChart;
